<button
  *ngIf="
    (permissions.hasPermission(permission.Create, activity) | async) &&
    resourceId
  "
  class="floatFab"
  mat-fab
  color="primary"
  matTooltip="Add Users"
  i18n-matTooltip
  (click)="addUsers()"
>
  <mat-icon>add</mat-icon>
</button>

<button
  [matMenuTriggerFor]="menu"
  *ngIf="selection.hasValue()"
  [ngClass]="{ floatFabSecondary: !!resourceId, floatFab: !resourceId }"
  [matBadge]="selection.count"
  matBadgeColor="accent"
  mat-fab
  color="primary"
>
  <mat-icon>manage_accounts</mat-icon>
</button>

<mat-menu #menu="matMenu">
  <button
    mat-menu-item
    (click)="reissueSelected()"
    [disabled]="
      (permissions.hasPermission(permission.Delete, activity) | async) === false
    "
  >
    <mat-icon color="primary">reply_all</mat-icon>
    <span i18n>Reissue Invitations</span>
  </button>
  <button
    mat-menu-item
    (click)="deleteSelected()"
    [disabled]="
      (permissions.hasPermission(permission.Delete, activity) | async) === false
    "
  >
    <mat-icon color="warn">delete</mat-icon>
    <span i18n>Delete users</span>
  </button>
</mat-menu>

<div fxFill fxLayout="column" fxLayoutGap="15px">
  <div class="table-wrapper">
    <table
      mat-table
      [dataSource]="displayedUsers!"
      matSort
      matSortActive="username"
      matSortDirection="asc"
      multiTemplateDataRows
    >
      <ng-container matColumnDef="select">
        <th
          mat-header-cell
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [aria-label]="checkboxLabel()"
          >
          </mat-checkbox>
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="icon">
        <th mat-header-cell style="width: 15px" *matHeaderCellDef></th>
        <td
          mat-cell
          style="width: 15px"
          *matCellDef="let user"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <mat-icon
            [color]="user === highlightedUser ? 'primary' : ''"
            svgIcon="account-check"
          ></mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="username">
        <th
          mat-header-cell
          mat-sort-header
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
          i18n
        >
          User Name
        </th>
        <td
          mat-cell
          *matCellDef="let user"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <span>{{ user.username }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th
          mat-header-cell
          mat-sort-header
          fxHide.lt-md
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
          i18n
        >
          Email
        </th>
        <td
          mat-cell
          *matCellDef="let user"
          fxHide.lt-md
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <a [routerLink]="['/mfa-users', user.email, 'registered']">{{
            user.email
          }}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="resourceName">
        <th
          mat-header-cell
          mat-sort-header
          fxHide.lt-md
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
          i18n
        >
          Resource Name
        </th>
        <td
          mat-cell
          *matCellDef="let user"
          fxHide.lt-md
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <a
            [routerLink]="[
              '/protected-resources',
              user.resourceId,
              'registered'
            ]"
            >{{ user.resourceName }}</a
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="created">
        <th
          mat-header-cell
          mat-sort-header
          fxHide.lt-md
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
          i18n
        >
          Created
        </th>
        <td
          mat-cell
          fxHide.lt-md
          *matCellDef="let user"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          {{ user.created | date:'short' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th
          mat-header-cell
          mat-sort-header
          fxHide.lt-md
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
          i18n
        >
          Status
        </th>
        <td
          mat-cell
          fxHide.lt-md
          *matCellDef="let user"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <mat-icon
            color="primary"
            *ngIf="user.status === userStatus.Active"
            svgIcon="check-decagram"
          ></mat-icon>
          <mat-icon
            svgIcon="account-off"
            color="warn"
            *ngIf="user.status === userStatus.Disabled"
          ></mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="additionalUsernames">
        <th
          mat-header-cell
          fxHide.lt-md
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
          i18n
        >
          Additional Usernames
        </th>
        <td
          mat-cell
          fxHide.lt-md
          *matCellDef="let user"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <a (click)="handleAdditionalUsernamesClick(user, $event)">
            <span>{{ user.additionalUsernames?.length }} </span>
            <span *ngIf="user.additionalUsernames?.length > 0">{{
              user.additionalUsernamesExpanded ? '-' : '+'
            }}</span></a
          >
          <div
            class="indented"
            [@detailExpand]="
              user.additionalUsernamesExpanded ? 'expanded' : 'collapsed'
            "
          >
            <div *ngFor="let username of user.additionalUsernames">
              <span>{{ username }}</span>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="expanded">
        <td
          mat-cell
          [attr.colspan]="7"
          *matCellDef="let user"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <div
            class="user-detail"
            [@detailExpand]="user === expandedUser ? 'expanded' : 'collapsed'"
          >
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
              <mat-icon
                [color]="getPlatformColor(user.devicePlatform)"
                [svgIcon]="getPlatformIcon(user.devicePlatform)"
              ></mat-icon>
              <span>{{ user.deviceModel }}</span>
              <span>{{ user.deviceVersion }}</span>
              <button mat-button (click)="updateUser(user)" i18n>Edit</button>
              <button mat-button (click)="getSupportCode(user)" i18n>
                Support
              </button>
              <ng-container *ngIf="currentCode">
                <span i18n
                  >Please provide the user with the following code:
                </span>
                <span class="mat-body-strong">{{ currentCode }}</span>
                <button
                  mat-icon-button
                  color="warn"
                  (click)="getSupportCode(user)"
                >
                  <mat-icon>refresh</mat-icon>
                </button>
              </ng-container>
            </div>
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        fxHide.lt-md
        *matHeaderRowDef="
          [
            'select',
            'icon',
            'username',
            resourceId ? 'email' : 'resourceName',
            'created',
            'status',
            'additionalUsernames'
          ];
          sticky: true
        "
      ></tr>
      <tr
        mat-row
        class="highlightRow user-row"
        (click)="
          expandedUser = expandedUser === row ? null : row; currentCode = null
        "
        *matRowDef="
          let row;
          columns: [
            'select',
            'icon',
            'username',
            resourceId ? 'email' : 'resourceName',
            'created',
            'status',
            'additionalUsernames'
          ]
        "
        (mouseenter)="highlightedUser = row"
        (mouseleave)="highlightedUser = null"
      ></tr>
      <tr
        mat-row
        *matRowDef="let user; columns: ['expanded']"
        class="user-detail-row"
      ></tr>
    </table>
  </div>
  <div *pcpHeaderInject="headerItemLocation.end">
    <button
      color="primary"
      mat-raised-button
      [routerLink]="['..', 'pending']"
      fxLayout="row"
      fxLayoutAlign="space-around center"
      fxLayoutGap="15px"
    >
      <span i18n *ngIf="numOfPendingUsers > 0">
        {{ numOfPendingUsers }} Pending Registrations
      </span>
      <span i18n *ngIf="numOfPendingUsers === 0">
        No Pending Registrations
      </span>
      <mat-icon class="mat-icon-rtl-mirror"> arrow_forward </mat-icon>
    </button>
  </div>
</div>
